import { Box, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import {
  AdditionalFormFieldProps,
  BaseFormFieldDefinition,
} from "@pimo/pimo-components/src/lib/pimo-components/pimo-form/form-field";

export const QUESTIONNAIRE_BLOCK_HEADER_FIELD_TYPE =
  "questionnaireBlockHeader" as const;

export type QuestionnaireBlockHeaderFieldDefinition = BaseFormFieldDefinition<
  typeof QUESTIONNAIRE_BLOCK_HEADER_FIELD_TYPE
> & {
  blockTitle: string;
  blockCode?: string;
  blockDescription?: string;
};

export const QuestionnaireBlockHeaderField = ({
  blockTitle,
  blockCode,
  blockDescription,
}: QuestionnaireBlockHeaderFieldDefinition & AdditionalFormFieldProps) => {
  return (
    <Box sx={{ mb: 1 }}>
      <Typography sx={{ fontSize: 20, fontWeight: 600 }}>
        {blockCode
          ? `${blockCode.replace(/^B/, "")} – ${blockTitle}`
          : blockTitle}
      </Typography>
      {blockDescription && (
        <Typography sx={{ fontSize: 14, color: grey[600], mt: 0.5 }}>
          {blockDescription}
        </Typography>
      )}
    </Box>
  );
};
